$(document).ready(function () {
    console.log("DEBUG_ jea-script-allpage loaded");
    var jea_navbar = document.getElementById("jea-sticky-navbar");
    var jea_navbar2 = document.getElementById("jea-sticky-navbar2");
    var icon_bar = document.getElementById("jea-navbar");
    var jea_sidebar = document.getElementById("sidebar");
    // var jea_floatHome = document.getElementById("float-home");

    //get offset position in pixel of navbar
    var jea_sticky = icon_bar.offsetTop;
    // var jea_floatHome_sticky = jea_floatHome.offsetTop;
    // console.log("DEBUG floatHome orig:"+jea_floatHome_sticky);

    var scroll = $(window).scrollTop()
    //console.log("DEBUG scroll orig:"+scroll);

    $(window).scroll(function (event) {
        if (window.innerWidth >= 800) {
          jea_navbar.style.display = "none";
          jea_navbar2.style.display = "none";
          return; // stop the scroll handler here
        }
        scroll = $(window).scrollTop(); //get in pixel
        //console.log("DEBUG scrolling..."+scroll);
        // $("#jeaheadertest").text(jea_sticky);
        if (scroll >= jea_sticky) {
            jea_navbar.classList.add("jea-sticky");
            jea_navbar.style.display = "flex";
          
            jea_navbar2.classList.add("jea-sticky");
            jea_navbar2.style.display = "flex";
            // jea_sidebar.classList.add("jea-sidebar");
        } else {
            jea_navbar.classList.remove("jea-sticky");
            jea_navbar.style.display = "none";
          
            jea_navbar2.classList.remove("jea-sticky");
            jea_navbar2.style.display = "none";
            // jea_sidebar.classList.remove("jea-sidebar");
        }

        // sticky button for float-home aug 20, 2022
        // if (scroll > 15) {
        //     jea_floatHome.classList.remove("float-home-icon");
        //     jea_floatHome.classList.add("float-home-icon-v2");
            
        // } else {
        //     jea_floatHome.classList.remove("float-home-icon-v2");
        //     jea_floatHome.classList.add("float-home-icon");
        // }
    });
    let t = "-he";
    let qty = parseInt($(".jea-qty-input").val());
    let MAX_QTY = parseInt($("#jea-hidden-qty").val());
    $("#jea-add").click(function(){
        qty = parseInt($(".jea-qty-input").val()) + 1;
        // console.log("DEBUG_"+qty);
        if (qty >= MAX_QTY) {
            $(".jea-qty-input").val(MAX_QTY);
        } else {
            $(".jea-qty-input").val(qty);
        }
    });

    $("#jea-sub").click(function(){
        qty = parseInt($(".jea-qty-input").val()) - 1;
        // console.log("DEBUG_"+qty);
        if (qty <= 1) {
            $(".jea-qty-input").val(1);
        } else {
            $(".jea-qty-input").val(qty);
        }
    });
    // FOR SIDEBAR

    //for video
    $('body').on('click touchstart', function () {
        try{
            const videoElement = document.getElementById('jeavid');
            if (videoElement.playing) {
                // video is already playing so do nothing
            }
            else {
                // video is not playing
                // so play video now
                videoElement.play();
            }
        } catch(e){
            //console.log(e.message);
        }
        
    });

    //cart subtotal
    
    $(window).on('pageshow', function() {
        //$('#cartform > small > div.cart-actions.clearfix > div.action-main > div > h2 > span.price-money > span.wholesale-cart-total > span:last-child').css("background-color", "yellow");
        
        //subtotal sa ibaba
        var subtotal = $('#cartform > small > div.cart-actions.clearfix > div.action-main > div > h2 > span.price-money > span.wholesale-cart-total > span:last-child').text();
        //subtotal sa itaas
        $('#cartform > div.jea-subtotal > h1 > strong > span.price-money').text(subtotal);

        console.log("DEBUG CART: " + c);
    });

    //image loop on hover for desktop
    var myInterval = false;
    $('.product_img-wrapper').on({
        mouseenter:function(e){
            console.log("mouse in");
            let imgid = $(e.target);
            console.log(imgid);
            imgid = $(e.target).attr('id');
            console.log(imgid);
            if(31236602593506 == imgid){
                // let $imgGrp = $('.block-grid .thumbnail img');
                let $imgGrp = $(e.target);
                console.log($imgGrp);
                let $parent = $imgGrp.parent();
                let $siblings = $parent.children('.thumb-image');
                let $firstImg = $parent.children('.thumb-image:first');
                console.log($siblings);
                $nextImg = $siblings.eq(1).attr('data-ezsd-slide--hidden');
                console.log($nextImg);
                
                $firstImg.attr('data-ezsd-slide--hidden','true');
                $firstImg.css('display','none');
                //$firstImg.fadeOut('fast');


                $lastImg = $siblings.eq(2);
                $lastImg.removeAttr('data-ezsd-slide--hidden');
                $lastImg.css('display','');

                $imgGrp = $(e.target);
            }
        },
        mouseleave:function(e){
            console.log("mouse out");
            let imgid = $(e.target).attr('id');
            if(31236602593506 == imgid){
                // let $imgGrp = $('.block-grid .thumbnail img');
                let $imgGrp = $(e.target);
                console.log($imgGrp);
                let $parent = $imgGrp.parent();
                let $siblings = $parent.children('.thumb-image');
                let $firstImg = $parent.children('.thumb-image:first');
                console.log($siblings);
                $nextImg = $siblings.eq(1).attr('data-ezsd-slide--hidden');
                console.log($nextImg);
                
                $lastImg.attr('data-ezsd-slide--hidden','true');
                $lastImg.css('display','none');


                $firstImg = $siblings.eq(0);
                $firstImg.removeAttr('data-ezsd-slide--hidden');
                $firstImg.css('display','');

                $imgGrp = $(e.target);
            }
        }
    });
    /*
    $('.thumb-image')
        //.addClass("extra")
        .hover(function(e){
            console.log("mouse in");
            //'#31236491968738' -> first image
            let imgid = $(e.target).attr('id');
            console.log(imgid);
            if(31236602593506 == imgid){
                let $imgGrp = $(e.target);
                let $parent = $imgGrp.parent();
                let $siblings = $parent.children('.thumb-image');
                let $firstImg = $parent.children('.thumb-image:first');
                console.log($siblings);
                $nextImg = $siblings.eq(1).attr('data-ezsd-slide--hidden');
                console.log($nextImg);
                
                $firstImg.attr('data-ezsd-slide--hidden','true');
                $firstImg.css('display','none');

                $lastImg = $siblings.eq(2);
                $lastImg.removeAttr('data-ezsd-slide--hidden');
                $lastImg.css('display','');
            }
            // if(31236602593506 == imgid){
            //     console.log("same id");
            //     let count = $('.addtc-parent img', this);
            //     console.log(count.length);
            //     console.log(count);

            //     let $imgGrp = $(e.target);
            //     console.log($imgGrp);

            //     let $parent = $imgGrp.parent();
            //     console.log($parent);

            //     let $firstImage = $parent.children('.thumb-image:first');
            //     console.log($firstImage);

            //     let iOffSet = $firstImage.offset();
            //     console.log(iOffSet);

            //     myInterval = setInterval(function(){
            //         let $nextImg;
            //         $firstImage.hide();
            //         //console.log('DEBUG 0');
            //         //console.log($imgGrp.next('.thumb-image').length);
            //         if($imgGrp.next('.thumb-image').length == 0) {
            //             console.log('DEBUG 1');
            //             console.log($imgGrp);
            //             $imgGrp.fadeOut('normal');
            //             $imgGrp = $firstImage;
            //             console.log('DEBUG 2');
            //             console.log($imgGrp);
            //             $nextImg = $imgGrp;
            //         } else {
            //             $nextImg = $imgGrp.next('.thumb-image');
            //             console.log('DEBUG 3');
            //             console.log($nextImg); }
            //         if($imgGrp != $nextImg){
            //             $imgGrp.fadeOut('normal');
            //             console.log('DEBUG 4');
            //             console.log($imgGrp); }
            //         // $nextImg.css({
            //         //     'top':iOffSet.top,
            //         //     'left':iOffSet.left,
            //         //     'position':'absolute'
            //         // });
            //         $nextImg.fadeIn('normal');
            //         $imgGrp = $nextImg;
            //     }, 750);
            // }
        },
        function(){
            console.log("mouse out");
            // let $imgGrp = $(this);
            // let $parent = $imgGrp.parent();
            // let $firstImage = $parent.children('.thumb-image:first');
            // if($(this).attr('src') != $firstImage.attr('src')){
            //     $(this).fadeOut('fast');
            // }
            // $firstImage.fadeIn('fast');
            // clearInterval(myInterval);
            // myInterval = false;
        });
        // .mouseout(function(e){
        //     console.log("mouse out");
            //$('#31236491968738').show();
            // let $imgGrp = $(this);
            // let $parent = $imgGrp.parent();
            // let $firstImage = $parent.children('.thumb-image:first');
            // if($(this).attr('src') != $firstImage.attr('src')){
            //     $(this).fadeOut('fast');
            // }
            // $firstImage.fadeIn('fast');
            // clearInterval(myInterval);
            // myInterval = false;
        // });

        */
       const nn = ''
       console.log(nn);
       
       

});

function closeNav() {
    $('body').removeClass("active-nav");
}

function increaseQty(id){
    // Get current quantity
    let qty = "updates_";
    qty = qty + id;
    let currentQty = parseInt($("#"+qty).val());

    // Get total quantity
    let maxQty = "maxQty_";
    maxQty = maxQty + id;
    let MAX_QTY = parseInt($("#"+maxQty).val());

    if (MAX_QTY > currentQty) {
        $("#"+qty).val(currentQty + 1);
    } else {
        $("#"+qty).val(MAX_QTY);
    }
}

function decreaseQty(id){
    let qty = "updates_";
    qty = qty + id;
    let currentQty = parseInt($("#"+qty).val());

    if (currentQty > 1) {
        $("#"+qty).val(currentQty - 1);
    } else {
        $("#"+qty).val(1);
    }
}